import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Re-export date formatters from their canonical location for backward compat
export { formatDate, formatDuration } from './date';

// User display name — resolves preferred name → display name → legal name → email → slackUsername
export function getUserDisplayName(user: {
  preferredFirstName?: string | null;
  preferredLastName?: string | null;
  displayName?: string | null;
  legalFirstName?: string | null;
  legalLastName?: string | null;
  name?: string | null;
  email?: string | null;
  slackUsername?: string | null;
}): string {
  if (user.preferredFirstName) {
    return [user.preferredFirstName, user.preferredLastName].filter(Boolean).join(' ');
  }
  if (user.displayName) return user.displayName;
  if (user.legalFirstName) {
    return [user.legalFirstName, user.legalLastName].filter(Boolean).join(' ');
  }
  return user.name || user.email || user.slackUsername || 'Unknown';
}
